
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'CombinationsProductsControls',
})
export default class CombinationsProductsControls extends Vue {
    @Prop({ type: Boolean, default: true }) readonly displayNextArrow!: boolean;
    @Prop({ type: Boolean, default: false }) readonly displayPrevArrow!: boolean;
    @Prop({ type: Boolean, default: false }) readonly disableAddButton!: boolean;
    @Prop({ type: Boolean, default: false }) readonly disableNextButton!: boolean;
}
